export default __webpack_public_path__ + "static/media/marker.0ec7789c.svg";